import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Seo from './components/Seo'
import GuidesPage from './pages/GuidesPage'
import Home from './pages/Home'
import OpsAnalyticsPage from './pages/OpsAnalyticsPage'
import SearchIndexing from './pages/SearchIndexing'
import StaticPage from './pages/StaticPage'
import ToolMateAppPage from './pages/ToolMateAppPage'
import ToolDetail from './pages/ToolDetail'
import ToolsPage from './pages/ToolsPage'

const ParentResourceDashboard = lazy(() => import('./tools/ParentResourceDashboard'))

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Seo />
      <ScrollToTop />
      <Navigation />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/guides" element={<GuidesPage />} />
          <Route path="/tools" element={<ToolsPage />} />
          <Route
            path="/kids/*"
            element={
              <Suspense fallback={<div className="px-4 py-10 text-center text-slate-500">资源库加载中...</div>}>
                <ParentResourceDashboard />
              </Suspense>
            }
          />
          <Route path="/tool/:toolId" element={<ToolDetail />} />
          <Route path="/about" element={<StaticPage pageId="about" />} />
          <Route path="/privacy" element={<StaticPage pageId="privacy" />} />
          <Route path="/contact" element={<StaticPage pageId="contact" />} />
          <Route path="/disclaimer" element={<StaticPage pageId="disclaimer" />} />
          <Route path="/search-indexing" element={<SearchIndexing />} />
          <Route path="/ops/analytics" element={<OpsAnalyticsPage />} />
          <Route path="/app/toolmate/privacy" element={<ToolMateAppPage pageId="privacy" />} />
          <Route path="/app/toolmate/terms" element={<ToolMateAppPage pageId="terms" />} />
          <Route path="/app/toolmate/support" element={<ToolMateAppPage pageId="support" />} />
          <Route path="*" element={<div>页面未找到</div>} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
